var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35408 0.5C5.34077 0.500091 4.34218 0.75462 3.44161 1.24235C2.54104 1.73009 1.76462 2.43688 1.17711 3.30376C0.589601 4.17065 0.208048 5.17249 0.0642827 6.2257C-0.0794823 7.2789 0.0187097 8.35294 0.350667 9.3582C0.682624 10.3635 1.23872 11.2708 1.97256 12.0045C2.7064 12.7382 3.5967 13.277 4.56919 13.5759C5.54168 13.8749 6.56815 13.9253 7.56297 13.723C8.55778 13.5206 9.4921 13.0715 10.288 12.4129L13.0182 15.2796C13.1592 15.4226 13.348 15.5018 13.5441 15.5C13.7401 15.4982 13.9276 15.4156 14.0662 15.2701C14.2048 15.1245 14.2834 14.9277 14.2851 14.7218C14.2868 14.516 14.2115 14.3177 14.0753 14.1697L11.3451 11.3029C12.0837 10.319 12.5436 9.13669 12.6721 7.89118C12.8007 6.64567 12.5927 5.38732 12.0719 4.26014C11.5511 3.13296 10.7387 2.1825 9.72748 1.51752C8.71629 0.852541 7.54722 0.499916 6.35408 0.5ZM1.49466 7.17235C1.49466 5.81911 2.00664 4.5213 2.91795 3.56442C3.82927 2.60754 5.06528 2.06996 6.35408 2.06996C7.64287 2.06996 8.87889 2.60754 9.7902 3.56442C10.7015 4.5213 11.2135 5.81911 11.2135 7.17235C11.2135 8.52559 10.7015 9.8234 9.7902 10.7803C8.87889 11.7372 7.64287 12.2747 6.35408 12.2747C5.06528 12.2747 3.82927 11.7372 2.91795 10.7803C2.00664 9.8234 1.49466 8.52559 1.49466 7.17235Z",
    fill: "#9E9FA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0e472f8ce44b53011077a592b87aa74d.svg";
export { ForwardRef as ReactComponent };